import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class GateDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>The Graduate Aptitude Test in Engineering or GATE is a yearly examination conducted jointly by the 7 IITs at Mumbai, Kanpur, Delhi, Guwahati, Chennai, Kharagpur, Roorkee and IISc, Bengaluru on behalf of the National Coordination Board - GATE, The Department of Higher Education, Ministry of Education (MoE), Government of India. 
                    </p><br/>
                    <p>The exam primarily evaluates candidates' thorough understanding of undergraduate engineering and science courses for admission to master's degrees and employment by certain public sector businesses. The CSIR has also allowed GATE-qualified candidates to apply for a PhD at CSIR laboratories.  </p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">WHY MIET?</h5><br/>
						<p>Be it arts or science, MIET’s years of experience and the expertise of our educators help aspiring professionals excel at their dream exams. We offer you smart tips and techniques to shine in your exams. With our years of experience in training students to excel in the field of their choice, we also help students to excel in engineering sciences with our advanced GATE Classes.
						</p><br/>
						<p>To suit your comfort and needs, MIET offers different modes and timings of batches so that students can learn and grow at their pace. </p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <p><b>Mode of Classes </b>: Online, Offline & Hybrid</p>
                            <p><b>Classes </b>: Evening & Weekend Batches</p>
                            </blockquote>
                        </div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">Subjects</h5><br/>
						<p>GATE conducts exams in 29 different disciplines or subjects that the candidates can choose based on the undergraduate course, and interest of specialization. These subjects are:
						</p><br/>
						<ul>
                            <li>Aerospace Engineering</li>
                            <li>Agricultural Engineering</li>
                            <li>Architecture and Planning</li>
                            <li>Biomedical Engineering</li>
                            <li>Biotechnology	</li>
                            <li>Civil Engineering	</li>
                            <li>Chemical Engineering</li>
                            <li>Computer Science and Information Technology</li>
                            <li>Chemistry</li>
                            <li>Electronics and Communication Engineering</li>
                            <li>Environmental Science and Engineering	</li>
                            <li>Ecology and Evolution</li>
                            <li>Geology and Geophysics</li>
                            <li>Geomatics Engineering</li>
                            <li>Naval Architecture and Marine Engineering</li>
                            <li>Instrumentation Engineering</li>
                            <li>Mathematics</li>
                            <li>Mechanical Engineering</li>
                            <li>Mining Engineering</li>
                            <li>Metallurgical Engineering</li>
                            <li>Petroleum Engineering</li>
                            <li>Physics</li>
                            <li>Production and Industrial Engineering</li>
                            <li>Textile Engineering and Fiber Science</li>
                            <li>Engineering Sciences</li>
                            <li>Life Sciences</li>
                            <li>Humanities and Social Sciences</li>
                            <li>Statistics</li>
                        </ul>
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
						<h5 className="mb-0 mt-2">Exam Pattern:</h5><br/>
                        <p>Candidates have to answer a total of 65 questions worth 100 marks within 3 hours. These questions are a mix of MCQs (Multiple Choice Questions), MSQs (Multiple Select Questions) and Numerical Type Answers, wherein they have to type the answer. The paper is entirely computer-based.</p>
                        <p>The syllabus for GATE is designed to assess the comprehensive learnings of the candidate and comprises 3 or 4 types of questions:</p>
                        <ul>
                            <li>Verbal Ability </li>
                            <li>Numerical Ability/Reasoning</li>
                            <li>Technical Ability (based on the subject chosen by the candidate)</li>
                            <li>Engineering Mathematics (for select papers)</li>
                        </ul>
                        
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <h5 className="mb-0 mt-2">Paper Pattern & Marking Scheme</h5><br/>
                    <table>
							<tr>
								<th>Sections</th>
								<th>Number of Questions</th>
								<th>Marks allotted</th>
								<th>Total Marks</th>
							</tr>
							<tr>
								<td rowspan="2">General Aptitude (Numerical & Verbal Ability)</td>
								<td>5</td>
								<td>1</td>
								<td>5</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>5</td>
								<td>2</td>
								<td>10</td>
							</tr>
							<tr>
								<td rowspan="2">Technical</td>
								<td>25</td>
								<td>1</td>
								<td>25</td>
							</tr>
							<tr>
								<td>30</td>
								<td>2</td>
								<td>60</td>
							</tr>
							<tr>
								<td>Total</td>
								<td>65</td>
								<td>-</td>
								<td>100</td>
							</tr>
						</table><br/>
                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <p>For every wrong MCQ answer, there is negative marking from the final score. 1/3rd of the original marks are subtracted for incorrect MCQ answers, -0.33 for incorrect 1-mark answers and -0.66 for incorrect 2-mark answers. While there are no negative marks for MSQs and NATs, they do not get any partial credit.</p>
                   
                    <h5 className="mb-0 mt-2">Qualifying Marks:</h5>
                    <p>To qualify for the GATE exam, students need to get at least 25 or above out of 100.</p>

                    
					
                    </ScrollAnimation>	
					

                  </div>
		      </div>
			  <Sidebar courseRestriction="GATE"/>
		    </div>
		  </div>
		</div>

        }
}

export default GateDetails